import { Injectable } from '@angular/core';
import { User } from './user';
import { RepositoryImpl } from 'libs/arch/src/lib/repositories/repository-impl';
import { ApiService } from 'libs/arch/src/lib/api/api.service';

@Injectable({ providedIn: 'root' })
export class UsersRepository extends RepositoryImpl<User, User> {
  constructor(api: ApiService) {
    super(api.root.path('/users'), User, User);
  }
}
